import React from 'react';
import firebase from '../../firebase.js';

import hammer from '../../img/self-help/hammer.png'
import toolbox from '../../img/self-help/toolbox.png'
import bucket from '../../img/self-help/bucket.png'

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    render() {
        return (
            <div style={{"margin":"27px"}}>
                <Panel 
                title="My Wellbeing Plan"
                body="Use this plan to help you make sure you look after yourself and know what to do if things feel difficult for you."
                download="well-being plan.pdf"
                button="Download My Wellbeing Plan"
                idx="1"
                icon={hammer}
                />
                <Panel 
                title="Learn about your stress"
                body="Take a look at this section to learn more about stress and ways of managing it."
                download="stress bucket.pdf"
                button="Download Stress Guide"
                idx="2"
                icon={bucket}
                />
                <Panel 
                title="Coping Toolbox"
                body="See our coping toolbox for some suggestions of coping tools you might want to try if things feel difficult."
                download="coping toolbox.pdf"
                button="Download the Coping Toolbox"
                idx="3"
                icon={toolbox}
                />
            </div>
        )
    }
}

class Panel extends React.Component {
    constructor(props) {
      super(props);
      this.props = props;
    }
    
    render() {
      const storageRef = firebase().storage().ref();
      storageRef.child(this.props.download).getDownloadURL()
      .then((url) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        // xhr.onload = function(event) {
        //   xhr.response;
        // };
        xhr.open('GET', url);
        xhr.send();

        const aHref = document.getElementById(this.props.idx);
        aHref.href = url
      });


      let body = null;
      if (this.props.body) {
        body = <div className="body">{this.props.body} </div>
      }

      return (
        <div className="wellbeing-panel">
            <h1 className="title">{this.props.title}</h1>
            {body}
            <a target='_blank' id={this.props.idx} className="download-btn"><img alt={"Icon for " + this.props.title} className='download-icon' src={this.props.icon} />{this.props.button}</a>
        </div>
      )
    }
}






// WEBPACK FOOTER //
// ./src/components/Help/selfHelp.js